export class DatasetDescription {
  public hasEvents = false;
  public hasPatientFields = false;
  public hasSampleFields = false;
  public hasMatrixFields = false;
  public hasHeatmappableFields = false;
  public hasMutations = false;
  public hasSurvival = false;
  public hasPrecomputed = false;
  public hasCopyNumber = false;
  public hasRNACountsTable = false;
  public mutationVariantNames = [];
}
